<script>
import { mapGetters } from 'vuex';

export default {
	name: 'LinksMixin',
	computed: {
		...mapGetters([
			'getAudience',
			'getFundAttributes'
		]),
		quarterlyHoldingsLink() {
			return `/${this.getAudience}/investments/insurance-funds/quarterly-holdings/${this.$route.params.vehicleId}`;
		},
		qsuPdfLink() {
			return `/${this.getAudience}/pdf/shareholder/INGEMUX-998-128851.pdf`;
		},
		detailPageLink() {
			return `/${this.getAudience}/investments/insurance-funds/${this.$route.params.vehicleId}`;
		},
		fundSymbol() {
			return this.getFundAttributes && this.getFundAttributes.FundSymbol || '';
		},
		shareClass() {
			return this.getFundAttributes && this.getFundAttributes.ShareClass || '';
		},
		historicalPricesLink() {
			return `/${this.getAudience}/investments/historicalprices?fund=${this.fundSymbol.toLowerCase()}&shareclass=${this.shareClass}`;
		},
		historicalDistributionsLink() {
			return `/${this.getAudience}/investments/historicaldistributions?fund=${this.fundSymbol.toLowerCase()}&shareclass=${this.shareClass}`;
		},
		/* Capital group has requested that we add .htm to all links that lead to a new page when in the integrated env. CG-12588 */
		integratedURLFormat() {
			return this.isMarkitEnvironment ? '' : '.htm';
		},
		isMarkitEnvironment() {
			const windowLocation = window.location.hostname;
			return (
				windowLocation.indexOf('localhost') !== -1 ||
				windowLocation.indexOf('markitqa') !== -1 ||
				windowLocation.indexOf('markitondemand') !== -1 ||
				windowLocation.indexOf('mdgapp') !== -1
			);
		}
	},
	methods: {
		dynamicDetailPageLink(fund) {
			return `/${this.getAudience}/investments/insurance-funds/${fund}${this.integratedURLFormat}`;
		},
		isNonIntegratedEnv(host) {
			let isNonIntegrated = host.indexOf('markitqa') > -1 || host.indexOf('localhost') > -1 || host.indexOf('dev.local') > -1 ||
				host.indexOf('mdgapp') > -1 || host.indexOf('markitondemand') > -1;

			return isNonIntegrated;
		}
	}
};
</script>
